import { Box } from "@mui/material";
import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DragMiniCard from "./DragMiniCard";

const DragCard = ({
  id,
  moduleName,
  taskName,
  startDate,
  endDate,
  hours,
  index,
  setActiveCard,
  priority,
}) => {
  return (
    <div
      className="dragcard"
      draggable
      onDragStart={() => setActiveCard(index)}
      onDragEnd={() => setActiveCard(null)}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2>{moduleName}</h2>
        <DragMiniCard
          style={{
            backgroundColor:
              priority == "low"
                ? "green"
                : priority == "medium"
                ? "orange"
                : "red",
                color:"white",
                fontWeight:"600"
          }}
        >
          {priority}
        </DragMiniCard>
      </div>

      <h3>{taskName}</h3>
      <div className="dragCard_titlebox">
        <DragMiniCard style={{backgroundColor:'#b8fa91', color:'#000'}}>{hours}</DragMiniCard>
        <DragMiniCard style={{backgroundColor:'#c4fa6a', color:'#000'}}>{startDate}</DragMiniCard>
        <DragMiniCard style={{backgroundColor:'#6afacf', color:'#000'}}>{endDate}</DragMiniCard>

        <div>
          <DeleteIcon fontSize="10px" className="dragcard_icon" />
          <EditIcon fontSize="10px" className="dragcard_icon" />
        </div>
      </div>
    </div>
  );
};

export default DragCard;
